import { render, staticRenderFns } from "./editGroupBuyProduct.vue?vue&type=template&id=4dc99f48&scoped=true"
import script from "./editGroupBuyProduct.vue?vue&type=script&lang=js"
export * from "./editGroupBuyProduct.vue?vue&type=script&lang=js"
import style0 from "./editGroupBuyProduct.vue?vue&type=style&index=0&id=4dc99f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc99f48",
  null
  
)

export default component.exports